export const getDomainNameFromHost = (host: string) => {
  const hostname = new URL(`http://${host}`).hostname

  if (hostname.includes('bonhams.com')) {
    return 'bonhams.com'
  }

  return hostname
}
